"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GuildCreateWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _GuildCreateWindowModule = _interopRequireDefault(require("./GuildCreateWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _GuildCreateWindow = _interopRequireDefault(require("./GuildCreateWindow.i18n"));

var _moneyToMoneyDivided = _interopRequireDefault(require("../../../../helpers/money/moneyToMoneyDivided"));

var _Money = _interopRequireDefault(require("../../../common/Money/Money"));

var _assets = require("../../../../assets");

var _guildMarks = _interopRequireDefault(require("../GuildMarkWindow/data/guildMarks"));

var _guildCloakColors = _interopRequireDefault(require("../GuildCloakColorWindow/data/guildCloakColors"));

var _ColorizedImage = _interopRequireDefault(require("../../../common/ColorizedImage/ColorizedImage"));

var _guildMarkColors = _interopRequireDefault(require("../GuildMarkColorWindow/data/guildMarkColors"));

var _inputElements = require("../../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function GuildCreateWindow(_ref) {
  var _ref$creationCost = _ref.creationCost,
      creationCost = _ref$creationCost === void 0 ? 100000 : _ref$creationCost,
      _ref$initialGuildName = _ref.initialGuildName,
      initialGuildName = _ref$initialGuildName === void 0 ? "" : _ref$initialGuildName,
      initialMarkFileName = _ref.initialMarkFileName,
      initialMarkColor = _ref.initialMarkColor,
      initialCloakColor = _ref.initialCloakColor,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(initialGuildName),
      _useState2 = _slicedToArray(_useState, 2),
      guildName = _useState2[0],
      setGuildName = _useState2[1];

  var _useState3 = (0, _react.useState)(initialMarkFileName),
      _useState4 = _slicedToArray(_useState3, 2),
      markFileName = _useState4[0],
      setMarkFileName = _useState4[1];

  var _useState5 = (0, _react.useState)(initialMarkColor),
      _useState6 = _slicedToArray(_useState5, 2),
      markColor = _useState6[0],
      setMarkColor = _useState6[1];

  var _useState7 = (0, _react.useState)(initialCloakColor),
      _useState8 = _slicedToArray(_useState7, 2),
      cloakColor = _useState8[0],
      setCloakColor = _useState8[1]; // eslint-disable-next-line no-nested-ternary


  var icon = markFileName ? markColor ? /*#__PURE__*/_react.default.createElement(_ColorizedImage.default, {
    imgSrc: "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(markFileName),
    color: markColor
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(markFileName),
    alt: ""
  }) : undefined;
  var checkGuildName = (0, _react.useCallback)(function () {
    console.error("TODO: check if guild name ist available", guildName);
  }, [guildName]);
  var openGuildMarkWindow = (0, _react.useCallback)(function () {
    console.error("TODO", "open window with current value as initial value");
    setMarkFileName(_guildMarks.default[Math.floor(Math.random() * _guildMarks.default.length)]);
  }, []);
  var openMarkColorWindow = (0, _react.useCallback)(function () {
    console.error("TODO", "open window with current value as initial value");
    setMarkColor(_guildMarkColors.default[Math.floor(Math.random() * _guildMarkColors.default.length)]);
  }, []);
  var openCloakColorWindow = (0, _react.useCallback)(function () {
    console.error("TODO", "open window with current value as initial value");
    setCloakColor(_guildCloakColors.default[Math.floor(Math.random() * _guildCloakColors.default.length)]);
  }, []);
  var createGuild = (0, _react.useCallback)(function () {
    console.error("TODO", "call callback method with data");
  }, []);
  var resetState = (0, _react.useCallback)(function () {
    setGuildName("");
    setCloakColor(undefined);
    setMarkFileName(undefined);
    setMarkColor(undefined);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    className: _GuildCreateWindowModule.default.windowControls,
    classNameDragHandler: _GuildCreateWindowModule.default.dragHandler,
    classNameCloseBtn: _GuildCreateWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.windowTitle
  }, formatMessage(_GuildCreateWindow.default.guildRegisterWindow)), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.guildName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.label
  }, formatMessage(_GuildCreateWindow.default.guildName)), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "text",
    onChange: function onChange(event) {
      return setGuildName(event.target.value);
    },
    className: _GuildCreateWindowModule.default.guildNameInput
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD_TEST,
    onClick: function onClick() {
      return checkGuildName();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.check)
  }, formatMessage(_GuildCreateWindow.default.check))), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.logoSetup
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD_MARK,
    onClick: function onClick() {
      return openGuildMarkWindow();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.guildMark)
  }, formatMessage(_GuildCreateWindow.default.guildMark)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD_MARK,
    onClick: function onClick() {
      return openMarkColorWindow();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.markColor)
  }, formatMessage(_GuildCreateWindow.default.markColor)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD_BACK,
    onClick: function onClick() {
      return openCloakColorWindow();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.cloakColor)
  }, formatMessage(_GuildCreateWindow.default.cloakColor)), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.logo,
    style: {
      backgroundColor: cloakColor
    }
  }, markFileName && icon)), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.costRow
  }, formatMessage(_GuildCreateWindow.default.itNeedsMoney, {
    dividedMoneyString: /*#__PURE__*/_react.default.createElement(_Money.default, {
      moneyDivide: (0, _moneyToMoneyDivided.default)(creationCost)
    })
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _GuildCreateWindowModule.default.buttonFooter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD,
    onClick: function onClick() {
      return createGuild();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.create)
  }, formatMessage(_GuildCreateWindow.default.create)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.GUILD,
    onClick: function onClick() {
      return resetState();
    },
    className: (0, _classnames.default)(_GuildCreateWindowModule.default.button, _GuildCreateWindowModule.default.reset)
  }, formatMessage(_GuildCreateWindow.default.reset))));
}